export var NodeCommand;
(function (NodeCommand) {
    NodeCommand["setValue"] = "node.set_value";
    NodeCommand["refreshInfo"] = "node.refresh_info";
    NodeCommand["getDefinedValueIDs"] = "node.get_defined_value_ids";
    NodeCommand["getValueMetadata"] = "node.get_value_metadata";
    NodeCommand["beginFirmwareUpdate"] = "node.begin_firmware_update";
    NodeCommand["updateFirmware"] = "node.update_firmware";
    NodeCommand["abortFirmwareUpdate"] = "node.abort_firmware_update";
    NodeCommand["pollValue"] = "node.poll_value";
    NodeCommand["setRawConfigParameterValue"] = "node.set_raw_config_parameter_value";
    NodeCommand["getRawConfigParameterValue"] = "node.get_raw_config_parameter_value";
    NodeCommand["refreshValues"] = "node.refresh_values";
    NodeCommand["refreshCCValues"] = "node.refresh_cc_values";
    NodeCommand["ping"] = "node.ping";
    NodeCommand["getFirmwareUpdateCapabilities"] = "node.get_firmware_update_capabilities";
    NodeCommand["getFirmwareUpdateCapabilitiesCached"] = "node.get_firmware_update_capabilities_cached";
    NodeCommand["hasSecurityClass"] = "node.has_security_class";
    NodeCommand["getHighestSecurityClass"] = "node.get_highest_security_class";
    NodeCommand["testPowerlevel"] = "node.test_powerlevel";
    NodeCommand["checkLifelineHealth"] = "node.check_lifeline_health";
    NodeCommand["checkRouteHealth"] = "node.check_route_health";
    NodeCommand["getValue"] = "node.get_value";
    NodeCommand["getEndpointCount"] = "node.get_endpoint_count";
    NodeCommand["interviewCC"] = "node.interview_cc";
    NodeCommand["getState"] = "node.get_state";
    NodeCommand["setName"] = "node.set_name";
    NodeCommand["setLocation"] = "node.set_location";
    NodeCommand["setKeepAwake"] = "node.set_keep_awake";
    NodeCommand["getFirmwareUpdateProgress"] = "node.get_firmware_update_progress";
    NodeCommand["isFirmwareUpdateInProgress"] = "node.is_firmware_update_in_progress";
    NodeCommand["waitForWakeup"] = "node.wait_for_wakeup";
    NodeCommand["interview"] = "node.interview";
    NodeCommand["getValueTimestamp"] = "node.get_value_timestamp";
    NodeCommand["manuallyIdleNotificationValue"] = "node.manually_idle_notification_value";
    NodeCommand["setDateAndTime"] = "node.set_date_and_time";
    NodeCommand["getDateAndTime"] = "node.get_date_and_time";
    NodeCommand["isHealthCheckInProgress"] = "node.is_health_check_in_progress";
    NodeCommand["abortHealthCheck"] = "node.abort_health_check";
    NodeCommand["setDefaultVolume"] = "node.set_default_volume";
    NodeCommand["setDefaultTransitionDuration"] = "node.set_default_transition_duration";
    NodeCommand["hasDeviceConfigChanged"] = "node.has_device_config_changed";
    NodeCommand["createDump"] = "node.create_dump";
    NodeCommand["getSupportedNotificationEvents"] = "node.get_supported_notification_events";
    // Undocumented
    NodeCommand["checkLinkReliability"] = "node.check_link_reliability";
    // Undocumented
    NodeCommand["isLinkReliabilityCheckInProgress"] = "node.is_link_reliability_check_in_progress";
    // Undocumented
    NodeCommand["abortLinkReliabilityCheck"] = "node.abort_link_reliability_check";
})(NodeCommand || (NodeCommand = {}));
